import { render } from "./SbmReport.vue?vue&type=template&id=321b601c&scoped=true"
import script from "./SbmReport.vue?vue&type=script&lang=js"
export * from "./SbmReport.vue?vue&type=script&lang=js"

import "./SbmReport.vue?vue&type=style&index=0&id=321b601c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321b601c"]])

export default __exports__